import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  constructor(

    private http: HttpClient,
  ) { }

  // private userInfoUrl='https://omsuatv3.callhealth.com/OMS/api/auth.php/v1/gettokendata';
  private userInfoUrl='';
  getUserInfo(userInfo):Observable<object>{
    return this.http.post(`${this.userInfoUrl}`,userInfo)
  }
  
}
